import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets the `}<a parentName="p" {...{
          "href": "/api/../api/projects/shippingMethods#shippingmethod"
        }}>{`ShippingMethod`}</a>{`. `}<strong parentName="p">{`Prerequisites:`}</strong>{` The Cart must have a shipping address and the `}<inlineCode parentName="p">{`Single`}</inlineCode>{` `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#shippingmode"
        }}>{`ShippingMode`}</a>{`. This update action can fail with an `}<a parentName="p" {...{
          "href": "/api/../api/errors#general-400-invalid-operation"
        }}>{`InvalidOperation`}</a>{` if the referenced Shipping Method has a predicate which does not match the Cart.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setShippingMethod"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`shippingMethod`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#resourceidentifier"
          }}>{`ResourceIdentifier`}</a>{` to a `}<a parentName="li" {...{
            "href": "/api/../api/projects/shippingMethods#shippingmethod"
          }}>{`ShippingMethod`}</a>{` - Optional`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`externalTaxRate`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#externaltaxratedraft"
          }}>{`ExternalTaxRateDraft`}</a>{` - Optional`}<br parentName="li"></br>
          {`An external tax rate can be set if the cart has the `}<inlineCode parentName="li">{`External`}</inlineCode>{` `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#taxmode"
          }}>{`TaxMode`}</a>{`.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      